import React, { useRef, useEffect, useCallback } from "react";
import { SketchPicker } from "react-color";

import "./ColorPopup.css";

function ColorPopup({ open, setOpen, anchor, pickerColor, changePickerColor, pointColorPicker }) {
  const containerRef = useRef();
  let mouseInside = false;

  const bottom = pointColorPicker
    ? `${open ? 145 : 155}px`
    : `${window.innerHeight - anchor.getBoundingClientRect().y - window.scrollY + (open ? 10 : 20)}px`;

  const left = pointColorPicker
    ? "-55px"
    : `${anchor.getBoundingClientRect().x + anchor.getBoundingClientRect().width / 2 - 140}px`;

  useEffect(() => {
    setTimeout(() => {
      if (open) {
        window.addEventListener("click", handleClick);
        window.addEventListener("mousedown", handleMouseDown);
      } else {
        window.removeEventListener("click", handleClick);
        window.removeEventListener("mousedown", handleMouseDown);
      }
    }, 100);
  }, [open]);

  const handleClick = useCallback((e) => {
    if (containerRef.current && !containerRef.current.contains(e.target) && !mouseInside) setOpen(false);
  }, []);

  // this prevents the popup from closing when the user drags the mouse
  // out of it after initiating mousedown
  const handleMouseDown = useCallback((e) => {
    if (containerRef.current && containerRef.current.contains(e.target)) mouseInside = true;
    else mouseInside = false;
  }, []);

  return (
    <div
      ref={containerRef}
      className={`color-picker-container cancel nodrag ${open ? "visible" : "hidden"}`}
      style={{
        bottom: bottom,
        left: left,
      }}
    >
      <SketchPicker width={250} color={pickerColor} onChangeComplete={changePickerColor} />
    </div>
  );
}

export default ColorPopup;
